export default "__VITE_ASSET__Dk4xZ5Yg__"